export const SIAE_STATUS_EMPTY = '';
export const SIAE_STATUS_APPROVED = 'approved';
export const SIAE_STATUS_EXCLUDED = 'excluded';

export type SiaeStatus = typeof SIAE_STATUS_EMPTY | typeof SIAE_STATUS_APPROVED | typeof SIAE_STATUS_EXCLUDED;

export interface RegulationSettingsValue {
  allows18App?: boolean;
  siaeStatus?: SiaeStatus;
  abbonamentoId?: string | null;
  excludeFromC1?: boolean;
}

export interface RegulationSettingsErrors {
  siaeStatus?: string;
  abbonamentoId?: string;
}

export interface RegulationSettingsSectionProps {
  value: RegulationSettingsValue;
  onChange: (patch: Partial<RegulationSettingsValue>) => void;
  open: boolean;
  onToggleOpen: () => void;
  disabled?: boolean;
  errors?: RegulationSettingsErrors;
  dataTestId?: string;
}
